import { Stack } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";
import { EnterpriseCustomerSelectionCard } from "../components/EnterpriseCustomerState";
import { ItemsOfConcernPanel } from "../components/ItemsOfConcernPanel";
import { RecentWinsPanel } from "../components/RecentWinsPanel";
import { useGetCustomerContext } from "../queries/useGetCustomerContext";
import { useGetEnterpriseOverview } from "../queries/useGetEnterpriseOverview";
import { useGetItemsOfConcern } from "../queries/useGetItemsOfConcern";
import { useGetRecentWins } from "../queries/useGetRecentWins";
import { Route } from "../routes/_app.sandbox";

export function EnterpriseSandboxPage() {
  const { t } = useTranslation();
  const { externalCustomerId } = Route.useSearch();

  if (!externalCustomerId) {
    return (
      <EnterpriseCustomerSelectionCard
        description={t("enterprise.routes.sandbox.selectCustomerDescription")}
      />
    );
  }

  return <EnterpriseSandboxContent externalCustomerId={externalCustomerId} />;
}

function EnterpriseSandboxContent({
  externalCustomerId,
}: {
  externalCustomerId: string;
}) {
  const { data: customer } = useGetCustomerContext(externalCustomerId);
  const { data } = useGetEnterpriseOverview(customer.customerId);
  const { data: recentWinsData } = useGetRecentWins(customer.customerId);
  const { data: itemsOfConcernData } = useGetItemsOfConcern(
    customer.customerId,
  );

  return (
    <Stack gap={20}>
      <RecentWinsPanel
        data={recentWinsData}
        thirtyDaySavings={data.summary.totalCostSavings}
      />

      <ItemsOfConcernPanel
        data={itemsOfConcernData}
        costsAtRisk={data.summary.openAlertCostOfInaction}
        maintenanceRecommendations={
          data.summary.maintenanceRecommendedMachineCount
        }
      />
    </Stack>
  );
}
